/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Spinner,
  SvgIcon
} from "../"

import {
  getAvatarInitialsColour
} from '../../utils'


class LoggedInUser extends PureComponent {
  static propTypes = {
    accountId: PropTypes.string.isRequired,
    isEmployerGroupAccount: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string
  }

  state = {
    showMenu: false
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner type="brand" />
    }

    if (this.props.data.error) {
      return <div>...</div>
    }
    
    let firstName = this.props.data.me.firstName
    let lastName = this.props.data.me.lastName
    let initials = `${firstName[0]}${this.props.data.me.lastName[0]}`
    let avatarInitialsColour = getAvatarInitialsColour(initials)
    let employerName = this.props.isEmployerGroupAccount
        ? this.props.data.employergroup
          ? `${this.props.data.employergroup.friendlyName} (group)`
          : '... (group)'  // temp
        : this.props.data.employer
          ? this.props.data.employer.friendlyName
          : '...'  // temp

    return (
      <div
        className={`slds-grid${this.props.className ? ` ${this.props.className}` : ''}`}
        onClick={this.props.onClick
          ? () => this.props.onClick(`${firstName} ${lastName}`, employerName)
          : null
        }>
        <div className="slds-avatar slds-avatar_medium slds-avatar_circle slds-m-right_medium slds-m-top_xx-small">
          <abbr
            className={`slds-avatar__initials slds-icon-standard-user ${avatarInitialsColour ? `avatar-color_${avatarInitialsColour}` : ''}`}
            title={firstName}>
            {initials}
          </abbr>
        </div>
        <div>
          <div className="u-no-margin__b" style={{ fontSize: 'larger', fontWeight: 'bolder' }}>
            {firstName.indexOf(' ') > 1
              ? firstName.split(' ')[0]
              : firstName
            }
          </div>
          <div
            className="slds-text-body_small slds-text-color_weak"
            style={{ lineHeight: 1 }}>
            {employerName}
          </div>
        </div>
        <div className="slds-m-left_medium slds-m-top_x-small">
          <SvgIcon
            variant="utility"
            symbol="down"
            size="xx-small"
          />
        </div>
      </div>
    )
  }
}

const getUserInfo = gql`
  query($id: ID!, $employerLevelAccess: Boolean!, $employerGroupLevelAccess: Boolean!) {
    me {
      id
      firstName
      lastName
    }
    employer(id: $id) @include(if: $employerLevelAccess) {
      id
      friendlyName
    }
    employergroup(id: $id) @include(if: $employerGroupLevelAccess) {
      id
      friendlyName
    }
  }
`

const withData =
  graphql(getUserInfo, {
    options: ({ accountId, isEmployerGroupAccount }) => ({
      variables: {
        id: accountId,
        employerLevelAccess: !isEmployerGroupAccount,
        employerGroupLevelAccess: isEmployerGroupAccount
      }
    })
  })

export default withData(LoggedInUser)



// WEBPACK FOOTER //
// ./src/components/logged-in-user/index.js